import sha256 from 'crypto-js/sha256';
import { ImageAsset } from './ImageAsset';

var getImageAsset = function getImageAsset(imagePath, fileType) {
  var BASE_URL = 'https://dwhmnen8pl3zw.cloudfront.net/v1/web';
  var CLIENT_KEY = '1de6925c7fa68eb6c22728a94834b9fbcc356ad8e53681a648c5aa377bf7188b';
  var hash = sha256("".concat(CLIENT_KEY).concat(imagePath)).toString();
  var imageUrl = "".concat(BASE_URL).concat(imagePath, "/").concat(hash, ".").concat(fileType);
  var imageAsset = {
    url: imageUrl
  };
  return imageAsset;
};

export { getImageAsset, ImageAsset };